import { Banknote, CreditCard, Smartphone } from "lucide-react";
import { InfoRow } from "@/shared/components/ui/InfoRow";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { AppointmentChargeGuard } from "../components/AppointmentChargeGuard";
import { formatPaymentMoney, paymentCurrencyDigits } from "../types/paymentTypes";

const rowClassName = "rounded-[20px] border border-border bg-card";

export function AppointmentChargePage() {
  const { goToAppointmentChargeCash, goToAppointmentChargeCard } = useAppNavigation();
  return <AppointmentChargeGuard title="Take payment">
    {({ appointmentId, appointment, summary }) => {
      const supported = paymentCurrencyDigits(summary.currency) !== null;
      const cardAvailable = summary.canCharge && !!appointment.clientId && supported;
      return <>
        {summary.balanceMinor !== null && <p className="text-sm text-muted-foreground">Amount due {formatPaymentMoney(summary.balanceMinor, summary.currency)}.</p>}
        <fieldset disabled={!summary.canRecordCash || !supported} className="min-w-0 disabled:opacity-60">
          <InfoRow title="Cash" icon={<Banknote aria-hidden="true" />} className={rowClassName}
            subtitle="Record cash received from the customer."
            caption={summary.canRecordCash ? undefined : summary.cashUnavailableReason ?? "Cash cannot be recorded."}
            onClick={() => goToAppointmentChargeCash(appointmentId)} />
        </fieldset>
        <fieldset disabled className="min-w-0 disabled:opacity-60">
          <InfoRow title="Card reader" subtitle="Coming soon" icon={<Smartphone aria-hidden="true" />} className={rowClassName} />
        </fieldset>
        <fieldset disabled={!cardAvailable} className="min-w-0 disabled:opacity-60">
          <InfoRow title="Card details" icon={<CreditCard aria-hidden="true" />} className={rowClassName}
            subtitle="Use a saved card, this device, or a secure payment link."
            caption={cardAvailable ? undefined : summary.unavailableReason ?? "This appointment cannot be charged by card."}
            onClick={() => goToAppointmentChargeCard(appointmentId)} />
        </fieldset>
      </>;
    }}
  </AppointmentChargeGuard>;
}
